module.exports = __webpack_public_path__ + "static/media/job_category_4.74b9f546.png";